module.exports = __webpack_public_path__ + "img/av311.4a68f3d6.png";